<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 20H3a1 1 0 000 2h18a1 1 0 000-2zM21 8h-.72l-.81-3.24a1 1 0 00-1-.76H16V3a1 1 0 00-1-1H3a1 1 0 00-1 1v12a1 1 0 001 1h2.68a3 3 0 005.64 0h2.36a3 3 0 005.64 0H21a1 1 0 001-1V9a1 1 0 00-1-1zM8.5 16a1 1 0 111-1 1 1 0 01-1 1zm8 0a1 1 0 111-1 1 1 0 01-1 1zm3.5-2h-.68a3 3 0 00-5.64 0h-2.36a3 3 0 00-5.64 0H4V4h10v5a1 1 0 002 0V6h1.72l.4 1.62.6 2.38H20z"/></svg>